import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { SnackbarProvider, withSnackbar } from 'notistack';

class RoSnackComponent extends React.Component {
  showVariant = (variant, message) => {
    this.props.enqueueSnackbar(message, { variant });
  };

  render() {
    return (
      <Fragment>
        {React.Children.map(this.props.children, child => {
          return React.cloneElement(child, {
            ...this.props,
            onShowSnack: this.showVariant
          });
        })}
      </Fragment>
    );
  }
}

RoSnackComponent.propTypes = {
  enqueueSnackbar: PropTypes.func.isRequired
};

const RoSnackBox = withSnackbar(RoSnackComponent);

const RoSnack = props => (
  <SnackbarProvider maxSnack={props.max} {...props}>
    <RoSnackBox {...props} />
  </SnackbarProvider>
);

export default RoSnack;
